module.exports = __webpack_public_path__ + "fonts/AntykwaTorunskaCondLight-Regular.6b385cb4.ttf";